export default "__VITE_ASSET__CWCGB05p__"